import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChUpdatePhysiotherapyMutation as useChUpdatePhysiotherapyMutationType } from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChUpdatePhysiotherapyMutation.graphql"

const mutation = graphql`
  mutation useChUpdatePhysiotherapyMutation($input: Ch_updatePhysiotherapyPrescriptionInput!) {
    ch_updatePhysiotherapyPrescription(input: $input) {
      ch_PhysiotherapyPrescription {
        id
        ...chPhysiotherapyFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChUpdatePhysiotherapyMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChUpdatePhysiotherapyMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChUpdatePhysiotherapyMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChUpdatePhysiotherapyMutation }
